import { authedFetch } from "@/lib/auth";

/**
 * Mint a local-runner connect token for a project (`POST
 * /api/projects/:id/runner-tokens`, editor role, 24h expiry, rate
 * limited). The token is base64url JSON `{a, g, s, p, t}` the runner
 * reads with `--connect`. Null when the API refuses or is unreachable.
 */
export async function requestConnectToken(
  projectId: string,
): Promise<string | null> {
  const apiBase = import.meta.env.VITE_API_URL || "";
  try {
    const res = await authedFetch(
      `${apiBase}/api/projects/${projectId}/runner-tokens`,
      { method: "POST", headers: { "Content-Type": "application/json" } },
    );
    if (!res.ok) return null;
    const data = (await res.json()) as { connectToken?: string };
    return data.connectToken ?? null;
  } catch {
    return null;
  }
}

/** The one-line install + connect command shown to the user. */
export function localRunnerCommand(connectToken: string): string {
  return `curl -fsSL https://iamu.dev/r | sh -s -- ${connectToken}`;
}
